import { render, staticRenderFns } from "./MoleculeEditionBillingSatellites.vue?vue&type=template&id=cdb2cc16"
import script from "./MoleculeEditionBillingSatellites.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingSatellites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports